/**
 * Перечень действий для хранилища состояния приложения.
 */

export const ACTION_SIGN_OUT = "SIGN_OUT";
export const ACTION_LOAD_CONTEXT = "LOAD_CONTEXT";
export const ACTION_AUTO_UPDATE = "AUTO_UPDATE";
